import { LoginRepository } from "@/domain/repository/login-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class LogoutUsecase {
  //MARK:- init
  constructor(private readonly loginRepo: LoginRepository) {}

  //MARK: - execute
  async execute(): Promise<SATResult<void, SATError>> {
    const result = await this.loginRepo.logout();
    // 로그아웃 API 성공 여부와 무관하게 통신 암복호화에 사용되는 세션 키(AES_KEY)를 시큐어 스토리지에서 삭제
    await this.loginRepo.clearSecureSession();

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    console.log("[LogoutUsecase] :: execute :: 로그아웃 성공");
    return SATResult.success(undefined);
  }
}
